module.exports = __webpack_public_path__ + "img/middleground-bus-img1.a1549406.png";